import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgHome(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 3.70696C12.3165 3.31643 11.6833 3.31643 11.2928 3.70696L3.70701 11.2927C3.07704 11.9227 3.52321 12.9998 4.41411 12.9998H5.99989V18.9998C5.99989 19.5521 6.44761 19.9998 6.99989 19.9998H9.99989V16.9998C9.99989 16.4475 10.4476 15.9998 10.9999 15.9998H12.9999C13.5522 15.9998 13.9999 16.4475 13.9999 16.9998V19.9998H16.9999C17.5522 19.9998 17.9999 19.5521 17.9999 18.9998V12.9998H19.5857C20.4766 12.9998 20.9228 11.9227 20.2928 11.2927L12.707 3.70696Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);

var HomeSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { HomeSolid as default };
